import { Injectable } from '@angular/core';
import { EventApi } from '@fullcalendar/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  AddAgendaEventsAction,
  ReplaceAgendaEventAction,
  ReplaceAgendaEventsAction,
  SetAgendaEventsAction,
} from './agenda-events.actions';

export const AgendaEventsStateKey: Readonly<string> = 'agendaEvents';
export const AgendaEventsStateDefault: EventApi[] = [];

@State<EventApi[]>({
  name: AgendaEventsStateKey,
  defaults: AgendaEventsStateDefault,
})
@Injectable()
export class AgendaEventsState {
  @Action(SetAgendaEventsAction)
  setEvents(
    ctx: StateContext<EventApi[]>,
    { payload }: SetAgendaEventsAction
  ): void {
    ctx.setState(payload);
  }

  @Action(AddAgendaEventsAction)
  addEvents(
    ctx: StateContext<EventApi[]>,
    { payload }: AddAgendaEventsAction
  ): void {
    const newState = [...ctx.getState(), ...payload];

    ctx.setState(newState);
  }

  @Action(ReplaceAgendaEventAction)
  replaceEvent(
    ctx: StateContext<EventApi[]>,
    { payload }: ReplaceAgendaEventAction
  ) {
    const newState = ctx
      .getState()
      .filter(
        (event) =>
          (!event?.extendedProps?.dossier && !event?.extendedProps?.event) ||
          (!!event?.extendedProps?.dossier &&
            event?.extendedProps?.dossier?.id !== payload.idToReplace) ||
          (!!event?.extendedProps?.event &&
            event?.extendedProps?.event?.id !== payload.idToReplace)
      );

    newState.push(...payload.events);

    ctx.setState(newState);
  }

  @Action(ReplaceAgendaEventsAction)
  replaceEvents(
    ctx: StateContext<EventApi[]>,
    { payload }: ReplaceAgendaEventsAction
  ) {
    const newState = ctx
      .getState()
      .filter(
        (event) =>
          (!event?.extendedProps?.dossier && !event?.extendedProps?.event) ||
          (!!event?.extendedProps?.dossier &&
            !payload.idsToReplace?.includes(
              event?.extendedProps?.dossier?.id
            )) ||
          (!!event?.extendedProps?.event &&
            !payload.idsToReplace?.includes(event?.extendedProps?.event?.id))
      );

    newState.push(...payload.events);

    ctx.setState(newState);
  }
}
